/** @jsx jsx */
/** @jsxFrag React.Fragment */
import React, {useRef, useEffect} from 'react'
import {Global} from '@emotion/core'
import {jsx, Box} from 'theme-ui'
import {useMenus, useCurrentDoc} from 'docz'

import * as styles from './styles'
import {NavLink} from '~components/NavLink'
import {NavGroup} from '~components/NavGroup'
import {Logo} from "../Logo";
import {useAuth0} from "@auth0/auth0-react";

export const Sidebar = React.forwardRef((props, ref) => {
    const menus = useMenus()
    const currentDoc = useCurrentDoc()
    const currentDocRef = useRef()

    const {isAuthenticated, user, logout} = useAuth0();

    // Don't output the menu when the user is logged out.
    if (!isAuthenticated) return null;

    // Retrieve a list of roles.
    const {'https://www.citnow.com/role': assignedRoles} = user;

    useEffect(() => {
        if (ref.current && currentDocRef.current) {
            ref.current.scrollTo(0, currentDocRef.current.offsetTop)
        }
    }, [ref])

    return (
        <>
            <Box onClick={props.onClick} sx={styles.overlay(props)}>
                {props.open && <Global styles={styles.global}/>}
            </Box>
            <Box ref={ref} sx={styles.wrapper(props)} data-testid="sidebar">
                <Logo/>

                {menus &&
                menus.map(menu => {
                    // Check if the role is assigned to the logged in user.
                    if (menu.role && assignedRoles.indexOf(menu.role) === -1)
                        return null;
                    if (!menu.route)
                        return <NavGroup key={menu.id} item={menu} sidebarRef={ref}/>
                    if (menu.route === currentDoc.route) {
                        return (
                            <NavLink key={menu.id} item={menu} ref={currentDocRef}>
                                {menu.name}
                            </NavLink>
                        )
                    }
                    return (
                        <NavLink key={menu.id} item={menu}>
                            {menu.name}
                        </NavLink>
                    )
                })}

                {isAuthenticated ? (
                    <button sx={styles.headerButton}
                            onClick={() => logout({returnTo: typeof window !== `undefined` ? window.location.origin : null})}
                            aria-label={`Logout`}>
                        Logout
                    </button>
                ) : undefined}

                <small style={{fontSize: 10}}>The content of these documents are proprietary and confidential. No
                    part of these documents may be disclosed in any manner to a third party without the prior
                    written consent of &copy; Zype TV Ltd.</small>
            </Box>
        </>
    )
})